<template lang="html">

  <section class="politica-de-cookies">
  <div class="container">
    <h1>POLÍTICA DE COOKIES</h1>
    <p>
    La página web de MYWORKOUTSTUDIO <a href="www.myworkoutstudio.com" target="_blank">www.myworkoutstudio.com</a> es utiliza “cookies” con la finalidad de poder recabar información
    acerca del uso que se hace de ella.
    </p>
    <p>Utilizamos cookies para facilitar tu navegación en la página, distinguirte de otros usuarios, solucionar problemas y
    mejorar tu experiencia de uso. También podemos utilizar cookies para recabar información sobre tus referencias y
    personalizar nuestra web en base a ellas, previo tu consentimiento.</p>
    <p>
      <b>COOKIES</b>
    </p>
    <p>
      Las cookies son archivos que se descargan en tu dispositivo para almacenar información sobre las preferencias y usos
      que
      haces en nuestra página.
    </p>
    <p>
      La información que se guarda en estos archivos puede actualizarse y ser recuperada, e incluye datos como el momento en
      que visitas nuestra web, cuántas páginas visitas y en qué orden… así como el tiempo que empleas en él y los sitios que
      visitas antes y después.
    </p>
    <p>
      <b>TIPO DE COOKIES QUE SE USAN EN NUESTRA WEB</b>
    </p>
    <p>La página web de MYWORKOUTSTUDIO utiliza cookies de terceros.</p>
    <p><b>COOKIES DE TERCEROS</b></p>
    <p>Utilizamos el sistema de medición de Google, Analytics, para medir las interacciones de los usuarios con los
      contenidos
      en nuestra página, saber el número total de usuarios que tenemos y las partes más populares de la web.</p>
    <p><b>__UTMA</b></p>
    <p>Duración - Dos años a partir de la configuración o actualización</p>
    <p>Descripción - Se usa para distinguir usuarios y sesiones. La cookie se crea cuando se ejecuta la biblioteca
      JavaScript y
      no hay ninguna cookie __utma. La cookie se actualiza cada vez que se envían datos a Google Analytics.</p>
    <p><b>__UTMT</b></p>
    <p>Duración - 10 minutos</p>
    <p>Descripción - Se usa para limitar el porcentaje de solicitudes.</p>
    <p><b>__UTMB</b></p>
    <p>Duración - 30 minutos a partir de la configuración o actualización</p>
    <p>Descripción - Se usa para determinar nuevas sesiones o visitas. La cookie se crea cuando se ejecuta la biblioteca
      JavaScript y no hay ninguna cookie __utmb. La cookie se actualiza cada vez que se envían datos a Google Analytics.</p>
    <p><b>__UTMC</b></p>
    <p>Duración - Fin de la sesión del navegador</p>
    <p>Descripción - No se usa en ga.js. Se configura para interactuar con urchin.js. Anteriormente, esta cookie actuaba
      junto
      con la cookie __utmb para determinar si el usuario estaba en una nueva sesión o visita.</p>
    <p><b>__UTMZ</b></p>
    <p>Duración - Seis meses a partir de la configuración o actualización</p>
    <p>Descripción - Almacena la fuente de tráfico o la campaña que explica cómo ha llegado el usuario al sitio. La cookie
      se
      crea cuando se ejecuta la biblioteca JavaScript y se actualiza cada vez que se envían datos a Google Analytics.</p>
    <p><b>__UTMV</b></p>
    <p>Duración - Dos años a partir de la configuración o actualización</p>
    <p>Descripción - Se usa para almacenar datos de variables personalizadas de visitante. Esta cookie se crea cuando un
      programador usa el método _setCustomVar con una variable personalizada de visitante. También se usaba para el método
      _setVar retirado. La cookie se actualiza cada vez que se envían datos a Google Analytics.</p>
    <p>Además de las de Google Analytics, pueden establecerse cookies de terceros (por ejemplo, cuando haces clic sobre los
      iconos de redes sociales, Facebook, Twitter…; o ves vídeos alojados en otro sitio web, Youtube o Vimeo,
      principalmente).
      Estas cookies son establecidas por un dominio diferente y no podemos acceder a los datos almacenados en las mismas.
    </p>
    <p>Si quieres consultar todos los detalles sobre el uso de las cookies de Google Analytics en los sitios web, puedes
      acceder <a target="_blank"
        href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=es">pinchando
        aquí</a>.</p>
    <p><b>CONSENTIMIENTO</b></p>
    <p>Si navegas por nuestra página web, estás consintiendo el uso de las cookies.</p>
    <p><b>DESHABILITAR Y BLOQUEAR COOKIES, Y RETIRAR TU CONSENTIMIENTO</b></p>
    <p>Puedes evitar que se almacenen estas cookies en tu dispositivo y seguir navegando en nuestra página (aunque algunos
      de
      los contenidos o servicios podrían ser limitados) navegando de incógnito o deshabilitando las cookies en tu navegador.
    </p>
    <p>Si estabas de acuerdo con la instalación de cookies pero has cambiado de idea, puedes retirar tu consentimiento
      simplemente eliminando las cookies que se hubieran almacenado en tu dispositivo.</p>
    <p>Para obtener información sobre cómo navegar de incógnito, deshabilitar y/o eliminar las cookies, tienes que leer la
      documentación de uso del navegador que utilizas sobre configuración y ajustes de cookies.</p>
    <p>Te dejamos enlaces a esta documentación de los navegadores más populares:</p>
    <p><a target="_blank" href="http://www.allaboutcookies.org/es/administrar-las-cookies/internet-explorer9-plus.html">•
        Internet Explorer 9</a></p>
    <p><a target="_blank"
        href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies">• Internet
        Explorer 11</a></p>
    <p><a target="_blank"
        href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies">• Microsft
        Edge</a></p>
    <p><a target="_blank"
        href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias">•
        Firefox</a></p>
    <p><a target="_blank" href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=es">•
        Chrome</a></p>
    <p><a target="_blank" href="https://support.apple.com/kb/ph21411?locale=es_ES">• Safari</a></p>
    <p><b>CAMBIOS EN LA POLÍTICA DE COOKIES</b></p>
    <p>Podríamos actualizar esta Política de Cookies en cualquier momento, por lo que te recomendamos que compruebes los
    términos cada vez que navegues en la página web de MYWORKOUTSTUDIO.</p>
  </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'politica-de-cookies',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
.politica-de-cookies {
  background: url("../../../static/img/bg-politicas.svg");
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 100px 0 100px;
  text-align: left;
  h1 {
    margin-bottom: 50px;
    line-height: 55px;
    @media screen and (max-width: 600px) {
      font-size: 25px;
      line-height: 26px;
      text-align: right;
      max-width: 100%;
    }
  }
  a {
    text-decoration: underline;
  }
  p {
    margin: 15px 0;
  }
  .container {
    @media screen and(max-width:1470px) {
      width: 100%;
      padding: 0 8vw !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/politica-de-cookies.vue